import React, { useState } from 'react';

import { AmazonProfile } from '../../models/Profile';

import './Setup.billLink.scss';

import Modal from 'react-modal';
import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import GraphQlClient from '../../services/graphql';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import SwitchCheckbox from '../Forms/SwtichCheckbox';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

function SetupBillingLink({ amazonProfile }: { amazonProfile: AmazonProfile }) {

    const [selfBillingEnabled, setSelfBillingEnabled] = useState(amazonProfile.selfBillingEnabled);
    
    const [setBillingEnabled] = useMutation(graphqlSchema.PROFILE.SETUP.setSelfBillingEnabled, {
        onCompleted: ({ setSelfBillingEnabled }) => {
            console.log('Updated Link: ', setSelfBillingEnabled);
            GraphQlClient.modifyClientMLprofile(setSelfBillingEnabled);
            sharedToasterSubject.next({ type: 'confirm', message: `Actualizó su preferencia de link de autofacturación` });
        },
        onError: () => {
        }
    })

    const [showPermissionsExample, setShowPermEx] = useState(false);
    const [showMailExample, setShowMailEx] = useState(false);

    const saveEnabled = () => {
        
        setSelfBillingEnabled(!selfBillingEnabled);
        setBillingEnabled({
            variables: {
                selfBillingEnabled: !selfBillingEnabled
            }
        })
    }

    const closeExamples = () => {
        setShowMailEx(false);
        setShowPermEx(false);
    }

    const openMailEx = () => {
        setShowMailEx(true);
    }

    const openPermEx = () => {
        setShowPermEx(true);
    }

    return (
        <div className="card" id="SetupBillLink">
            <div className="title">
                <h4>Enviar link de autofacturación a tu cliente</h4>
                <SwitchCheckbox onChange={saveEnabled} value={selfBillingEnabled} />
            </div>
            <div className="enableEmbedded">
                <p>
                    Para permitir a FiscalPOP enviar links de facturación a tus clientes de Amazon <b>es necesario agregar el correo de FiscalPOP a permisos de mensajería de tu Seller Central</b>. <br />
                </p>
                <ol>
                    <li>
                        <p>
                            Abre <a href="https://sellercentral.amazon.com.mx/messaging/permissions" target="_blank" rel="noopener noreferrer">"Messaging Permissions"</a> de tu seller central.
                            </p>
                    </li>
                    <li>
                        <p>
                            Agrega el correo <b className="accent">amazon@mailer.fiscalpop.com</b> dando click en "+ Add an email address" <b className="_example" onClick={openPermEx}>(Ver ejemplo)</b>
                        </p>
                    </li>
                    <li>
                        <p>
                            Da click en "Save" <b className="_example" onClick={openMailEx}>(Ver ejemplo)</b>
                        </p>
                    </li>
                    <li>
                        <p>
                            Activa la opción de este bloque una vez hayas terminado de dar de alta el correo de FiscalPOP en los pasos anteriores.
                            </p>
                    </li>
                </ol>
                <div className="entries">
                    <p>
                        El link de facturación se enviará una vez se entrgue el producto y tendrá el mes completo para obtener su fatura
                    </p>
                </div>
                <div className="example">


                </div>
            </div>
            <Modal
                isOpen={showPermissionsExample}
                onRequestClose={closeExamples}
                style={customStyles}
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
                contentLabel="FiscalPOP Modal"
            >
                <div id="_FiscalpopDialog">
                    <h4>
                        Ejemplo de "Message Permissions"
                    </h4>
                </div>
                <div>
                    <img alt="Ejemplo de permissions" src="https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/addPermissionsMws.png" className="imEx" />
                </div>
            </Modal>
            <Modal
                isOpen={showMailExample}
                onRequestClose={closeExamples}
                style={customStyles}
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
                contentLabel="FiscalPOP Modal"
            >
                <div id="_FiscalpopDialog">
                    <h4>
                        Ejemplo de "Agregar correo"
                    </h4>
                </div>
                <div>
                    <img alt="Ejemplo de guardar correo" src="https://fiscalpop.sfo2.cdn.digitaloceanspaces.com/assets/addEmailMWS.png" className="imEx" />
                </div>
            </Modal>
        </div>
    )
}

export default SetupBillingLink;
